var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7015 11.2643L7.93757 6.5L12.7015 1.7357C13.0982 1.33901 13.0982 0.694213 12.7015 0.29752C12.3048 -0.0991734 11.6601 -0.0991734 11.2634 0.29752L6.4995 5.06182L1.73557 0.29752C1.3389 -0.0991734 0.69416 -0.0991734 0.297497 0.29752C-0.0991658 0.694213 -0.0991658 1.33901 0.297497 1.7357L5.06143 6.5L0.297497 11.2643C-0.0991658 11.661 -0.0991658 12.3058 0.297497 12.7025C0.69416 13.0992 1.3389 13.0992 1.73557 12.7025L6.4995 7.93818L11.2634 12.7025C11.6601 13.0992 12.3048 13.0992 12.7015 12.7025C13.0995 12.3058 13.0995 11.6623 12.7015 11.2643Z",
    fill: "#FE1212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.337849782ecde8f8ff59fa67a6afe024.svg";
export { ForwardRef as ReactComponent };